export const slides = [
  {
    title: "1. Wybierz nagrodę",
    text: 'Wejdź w sekcję "nagrody" i wybierz nagrodę, którą chcesz odebrać.',
  },
  {
    title: "2. Odbierz nagrodę w lokalu",
    text: 'Wybierz "odbieram stacjonarnie" jeżeli dobierasz nagrode w lokalu. Personel pokażę Ci zieloną kartę z kodem QR. Zeskanuj kod QR z karty, nagroda zostanie odebrana.',
  },  
  {
    title: "4. Odbierz nagrodę online",
    text: 'Wybierz "odbierz online" jeżeli dobierasz nagrode podczas zamówienia online. Na ekranie w aplikacji pojawi się kod, który należy wpisać podczas składania zamówienia w sklepie internetowy.',
  },
];